import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import  { Toaster } from 'react-hot-toast';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import DashboardPage from './pages/DashboardPage';
import AlumniDirectoryPage from './pages/AlumniDirectory';
import JobBoardPage from './pages/JobBoardPage';
import EventsPage from './pages/EventsPage';
import CampaignsPage from './pages/CampaignsPage';
import InstituteDirectory from './pages/InstituteDirectory';
import AlumniProfilePage from './pages/AlumniProfilePage';
import InstituteProfilePage from './pages/InstitutesProfilePage';
import { JobProvider } from './hooks/JobContext';
import { EventProvider } from './hooks/EventContext';
import { CampaignProvider } from './hooks/CampaignContext';
import InstituteDashboard from './pages/InstituteDashboard';
import InstituteLandingPage from './pages/InstituteLandingPage';
import AdminDashboard from './pages/AdminDashboard';
import CRDSpace from './pages/CRDSpace';
import SuccessStoryTracking from './pages/SuccessStoryTracking';

function App() {
  return (
    <JobProvider>
      <EventProvider>
        <CampaignProvider>
          <BrowserRouter>
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow">
                <Routes>
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/signup" element={<SignupPage />} />
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/employerDashboard" element={<DashboardPage />} />
                  <Route path="/studentDashboard" element={<DashboardPage />} />
                  <Route path="/facultyDashboard" element={<DashboardPage />} />
                  <Route path="/directory" element={<AlumniDirectoryPage />} />
                  <Route path="/jobs" element={<JobBoardPage />} />
                  <Route path="/events" element={<EventsPage />} />
                  <Route path="/campaigns" element={<CampaignsPage />} />
                  <Route path='/institutes' element={<InstituteDirectory />} />
                  <Route path="/institute/:id" element={<InstituteProfilePage />} />
                  <Route path="/alumni/:id" element={<AlumniProfilePage />} />
                  <Route path="/instituteDashboard" element={<InstituteDashboard />} />
                  <Route path="/instituteProfile" element={<InstituteLandingPage />} />
                  <Route path="/admin" element={<AdminDashboard />} />
                  <Route path="/crd" element={<CRDSpace />} />
                  <Route path="/manzil" element={<SuccessStoryTracking />} />
                </Routes>
                <Toaster position="top-center" reverseOrder={false} />

              </main>
              <Footer />
            </div>
          </BrowserRouter>
        </CampaignProvider>
      </EventProvider>
    </JobProvider>
  );
}

export default App;